import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostKundenGruppeCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostKundenGruppeCommandService],
  exports: []
})
export class PostKundenGruppeCommandServiceModule { }
